export default "__VITE_ASSET__ebeYVgKA__"